import React from 'react';
import PropTypes from 'prop-types';

import { getSettingsDropDown } from '../../../redux/data/menu';
import { Stack, Typography } from '@mui/material';
import { VpIcon, VpInfoMenu } from '../..';

import { push } from 'react-router-redux';

const IconButonProps = { sx: { borderRadius: '5px' } };

export const SettingsDropdown = ({ isUserAClient, userName, dispatch, logOut, isSso }) => {
  const settings = getSettingsDropDown(isUserAClient, isSso);

  const onSelect = (item) => {
    switch (item?.text) {
      case 'Sign Out': {
        logOut();
        return;
      }
      default: {
        dispatch(push(item?.url));
        return;
      }
    }
  };
  const menuButton = (
    <Stack direction="row" gap="10px" alignItems="center">
      <Typography variant="dropDownText" noWrap>
        {userName}
      </Typography>
      <VpIcon icon="ChevronDown" sx={{ width: '14px' }} />
    </Stack>
  );

  return (
    <VpInfoMenu
      id={userName}
      menuItems={settings}
      loading={false}
      onSelect={onSelect}
      optionalLabelValue="text"
      IconButtonProps={IconButonProps}
      menuButton={menuButton}
    />
  );
};

SettingsDropdown.propTypes = {
  isUserAClient: PropTypes.bool,
  userName: PropTypes.string,
  isSso: PropTypes.bool,
  logOut: PropTypes.func,
  dispatch: PropTypes.func
};

export default SettingsDropdown;



// WEBPACK FOOTER //
// ./src/vp-ui/components/SettingsDropdown/SettingsDropdown.jsx